import React, {useRef} from 'react';
import styled from 'styled-components';
import Play from '../../assets/img/play.svg';

const VideoWrapper = styled.div`
	text-align: center;
	position: relative;
	flex-basis: 40%;
	-moz-transition: 300ms ease-in-out;
	-webkit-transition: 300ms ease-in-out;
	transition: 300ms ease-in-out;

	margin-bottom: ${(props) => (props.small ? '0' : '5em')};
`;

const VideoSrc = styled.video`
	position: relative;
	border-radius: 10px;
	display: block;
	width: 100%;
	margin: 0 auto;
	-moz-transition: 500ms ease-in-out;
	-webkit-transition: 500ms ease-in-out;
	transition: 500ms ease-in-out;

	&:hover {
		+ img {
			opacity: 1;
		}
	}

	@media screen and (min-width: 650px) {
		width: 90%;
	}
`;

const PlayButton = styled.img`
	position: absolute;
	cursor: pointer;
	left: 0;
	right: 0;
	margin: auto;
	transform: scale(1);
	margin: auto;
	z-index: 900;
	-moz-transition: 500ms ease-in-out;
	-webkit-transition: 500ms ease-in-out;
	transition: 500ms ease-in-out;

	top: ${(props) => (props.small ? 'auto' : '0')};
	opacity: ${(props) => (props.small ? '1' : '0')};
	bottom: ${(props) => (props.small ? '-20px' : '0')};

	&:hover {
		opacity: 1;
		transform: scale(1.2);
	}
`;

const VideoCaption = styled.small`
	display: block;
	padding-top: 15px;
`;

const toggleFullScreen = (e) => {
	var el = document.getElementById('video');
	if (el.requestFullscreen) {
		el.requestFullscreen();
	} else if (el.msRequestFullscreen) {
		el.msRequestFullscreen();
	} else if (el.mozRequestFullScreen) {
		el.mozRequestFullScreen();
	} else if (el.webkitRequestFullscreen) {
		el.webkitRequestFullscreen();
	}
};

const Video = ({url, thumbnail = '', caption = '', hasPlay = true, small = false, autoPlay = false}) => {
	const videoRef = useRef(null);
	return (
		<VideoWrapper small={small}>
			<VideoSrc id="video" ref={videoRef} preload="auto" poster={thumbnail} autoPlay={autoPlay} muted playsInline loop>
				<source src={url} type="video/mp4" />
			</VideoSrc>
			{hasPlay && <PlayButton small={small} src={Play} alt="Play Video" onClick={(e) => toggleFullScreen()} />}
			{caption && <VideoCaption>{caption}</VideoCaption>}
		</VideoWrapper>
	);
};

export default Video;
